<ca-tabset
    class="d-flex"
    [shouldBackButtonBeShown]="shouldBackButtonBeShown"
    (onTabsChanged)="openTab($event)"
    (onButtonClicked)="onButtonClicked.emit()"
    #tabset
>
    <ca-tab
        [tabTitle]="isMEDProjectEnabled ? ('FILE_EXPLORER.MED_TABS.DATA' | translate) : ('FILE_EXPLORER.TABS.MY_FILES' | translate)"
        [tabId]="FileExplorerTabs.MY_FILES"
        class="d-flex justify-content-center"
        [active]="startInTab === FileExplorerTabs.MY_FILES"
    >
        <ca-my-files
            [mode]="FILE_EXPLORER_MODE.SELECTION"
            [isFilesPage]="false"
            [isUploadModal]="isUploadModal"
            [isFilesStatusShown]="isFilesStatusShown"
            [titleKey]="isMEDProjectEnabled ? 'FILE_EXPLORER.MED_TABS.DATA' : 'FILE_EXPLORER.TABS.MY_FILES'"
            [columns]="
                isMEDProjectEnabled
                    ? [
                          { key: 'studyId', translationKey: 'GENERAL.MEDCOLUMN.STUDY_ID', defaultValue: '\u2014' },
                          { key: 'examType', translationKey: 'GENERAL.MEDCOLUMN.EXAM_TYPE', defaultValue: '\u2014' },
                          { key: 'device', translationKey: 'GENERAL.MEDCOLUMN.DEVICE', defaultValue: '\u2014' },
                      ]
                    : [
                          { key: 'checkbox' },
                          {
                              key: 'createdAt',
                              translationKey: 'GENERAL.COLUMN.CREATION_DATE',
                              defaultValue: '\u2014',
                              transform: 'resultDate',
                              transformDateFormat: 'dd.MM.yyyy',
                              transformTimeFormat: 'HH:mm:ss',
                          },
                          {
                              key: 'sizeInBytes',
                              translationKey: 'GENERAL.COLUMN.SIZE',
                              defaultValue: '\u2014',
                              transform: 'fileSize',
                          },
                          {
                              key: 'type',
                              translationKey: 'GENERAL.COLUMN.TYPE',
                              defaultValue: '\u2014',
                              transform: 'lowercase',
                          },
                      ]
            "
            [updateParameterQuery]="false"
            [truncateFileNameAtWidthOf]="truncateFileNameAtWidthOf"
            (onSelectMultipleFiles)="selectMultipleFiles($event)"
            (onClickOnFile)="selectFile($event)"
        ></ca-my-files>
    </ca-tab>
    <ca-tab
        *ngIf="!tabsToHide.includes(FileExplorerTabs.MY_RESULTS) && !isMEDProjectEnabled"
        [tabTitle]="'FILE_EXPLORER.TABS.MY_RESULTS' | translate"
        [tabId]="FileExplorerTabs.MY_RESULTS"
        class="d-flex justify-content-center"
        data-uit="apeer-file-tree-my-results-tab"
        [active]="startInTab === FileExplorerTabs.MY_RESULTS"
    >
        <ca-file-explorer-breadcrumb
            [rootTitle]="'FILE_EXPLORER.TABS.MY_RESULTS' | translate"
            (onClickOnBreadcrumbItem)="openFolder($event, true)"
            (onClickOnHome)="openTab(FileExplorerTabs.MY_RESULTS)"
        ></ca-file-explorer-breadcrumb>
        <ca-list-shell
            class="result-list-shell"
            [class.filter-and-searchbar-hidden]="!isResultRootFolder"
            (onTriggerSearchAndSort)="onTriggerResultSearch($event)"
            [emptyListMessage]="'MY_WORKSPACE.MY_RESULTS.NO_RESULTS' | translate"
            [totalItemsCount]="numberOfFilesAndFolders"
            [isLoading]="isResultsLoading"
            [showCategoryButton]="false"
            [isUploadModal]="isUploadModal"
            [isUploadModal]="isUploadModal"
            [sortOptions]="resultSortOptions"
            [pageSize]="defaultPageSize"
            [updateParameterQuery]="false"
            [skipTriggerSearchOnInit]="true"
            [hideFilterAndSearchBar]="!isResultRootFolder"
            [hidePagination]="!isResultRootFolder"
        >
            <!-- *ngIf "not loading" only, otherwise the additional height of progress-bar causes scrollbar jump-->
            <ng-container *ngIf="!isResultsLoading">
                <div
                    class="result-list-header button-box w-100 d-flex justify-content-start align-items-center"
                    [class.filter-and-searchbar-hidden]="!isResultRootFolder"
                >
                    <!-- "fake" table header to prevent jumping when switching tabs -->
                    <span class="ms-2" *ngIf="foldersToShow.length > 0 || filesToShow.length > 0">
                        {{ 'GENERAL.COLUMN.NAME' | translate }}
                    </span>
                    <button
                        *ngIf="currentFolder && currentFolder.files.length > 0"
                        type="button"
                        class="btn btn-secondary ms-3 btn-sm"
                        (click)="selectAllFilesOfFolder(currentFolder)"
                    >
                        {{
                            (currentFolder.files.length === 1 ? 'GENERAL.SELECT_FILE' : 'GENERAL.SELECT_ALL_FILES')
                                | translate: { numberOfFiles: currentFolder.files.length }
                        }}
                    </button>
                </div>
                <div data-uit="result-list" class="result-list">
                    <ca-folder-item
                        *ngFor="let folder of foldersToShow"
                        [name]="folder.name"
                        (click)="openFolder(folder)"
                        [numberOfFiles]="getNumberOfFilesOfAllSubfolders(folder)"
                    ></ca-folder-item>
                    <ca-file-item
                        *ngFor="let file of filesToShow; let first = first"
                        [class.first]="first"
                        [file]="file"
                        (click)="selectFile(file)"
                    ></ca-file-item>
                </div>
            </ng-container>
        </ca-list-shell>
    </ca-tab>
    <ca-tab
        *ngIf="!isMEDProjectEnabled"
        [tabTitle]="'FILE_EXPLORER.TABS.MY_DATASETS' | translate"
        [tabId]="FileExplorerTabs.MY_DATASETS"
        class="d-flex justify-content-center"
        [active]="startInTab === FileExplorerTabs.MY_DATASETS"
    >
        <ca-file-explorer-machine-learning-tab
            *ngIf="activeTab === FileExplorerTabs.MY_DATASETS"
            [actionsForFilesTable]="actionsForFilesTable"
            [columnsForFilesTable]="columnsForFilesTable"
            [isFilesStatusShown]="isFilesStatusShown"
            [foldersToHideIds]="foldersToHideIds"
            [shouldReloadMachineLearningTab]="reloadMachineLearningTab$"
            (onSelectFile)="selectFile($event)"
            (onMultipleFilesSelected)="selectMultipleFiles($event)"
        ></ca-file-explorer-machine-learning-tab>
    </ca-tab>
</ca-tabset>
